var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$store.state.isEquipment == 'phone' ? false : true)?_c('Normal'):_vm._e(),(this.$store.state.isEquipment == 'phone' ? true : false)?_c('Phone'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }